import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

import './Footer.scss';

import { ReactComponent as Email } from '../Icons/Footer/email.svg';
import { ReactComponent as Phone } from '../Icons/Footer/phone.svg';
import { ReactComponent as Instagram } from '../Icons/Footer/instagram.svg';
import { ReactComponent as Linkedin } from '../Icons/Footer/linkedin.svg';
import { ReactComponent as Logo } from '../Icons/Footer/logo.svg';
import { Link } from 'react-router-dom';
import { FirestoreCollection } from '@react-firebase/firestore';

const Footer = () => {

	return (
		<FirestoreCollection path='/footerSection'>
			{(data) => {
				if (data.isLoading) {
					return;
				}

				const footerData = data.value[0];
				const phones = footerData.phoneNumber || [];
				const emails = footerData.emais || [];

				return (
					<div>
						<div className="footer__wrapper">
							<div className="footer">
								<div className="footer__main">
									<div className="footer__main-logo">
										<Logo />
									</div>
									<div className="footer__main-text">
										{footerData.text}
									</div>
									{/* <div className="footer__main-socials">
										<Linkedin />
										<Instagram />
									</div> */}
								</div>
								<div className="footer__nav">
									<div className="footer__sub">Navigation</div>
									<div className="footer__nav-list">
										<div className="footer__nav-column">
											<ul>
												<ScrollLink
													to="trusted"
													smooth={true}
													offset={-80}
													duration={500}
												>
													<li>Features</li>
												</ScrollLink>
												<ScrollLink
													to="integrates"
													smooth={true}
													offset={-80}
													duration={500}
												>
													<li>Connect</li>
												</ScrollLink>
												<ScrollLink
													to="what"
													smooth={true}
													offset={-80}
													duration={500}
												>
													<li>Use Cases </li>
												</ScrollLink>
												<ScrollLink
													to="why"
													smooth={true}
													offset={-80}
													duration={500}
												>
													<li>Why SupportIntel?</li>
												</ScrollLink>
												<ScrollLink
													to="solo"
													smooth={true}
													offset={-80}
													duration={500}
												>
													<li>Plans for Every Team</li>
												</ScrollLink>
											</ul>
										</div>
										<div className="footer__nav-column">
											<ul>
												<ScrollLink
													to="faqs"
													smooth={true}
													offset={-80}
													duration={500}
												>
													<li>FAQ </li>
												</ScrollLink>
												<ScrollLink
													to="contacts"
													smooth={true}
													offset={-80}
													duration={500}
												>
													<li>Contact </li>
												</ScrollLink>
											</ul>
										</div>
									</div>
								</div>
								<div className="footer__contact">
									<div className="footer__sub-phone">Contact</div>
									<div className="footer__contact-phone">
										<div className="phone__logo">
											<Phone />
										</div>
										<div className="footer__contact-info">
											{phones.map((phone: { number: string }, i: number) => (
												<div className="footer__number" key={i}>{phone.number}</div>
											))}
											{/* <div className="footer__number">+31 (33) 245 55 11</div>
											<div className="footer__number">+380 (99) 111 84 33</div> */}
										</div>
									</div>
									<div className="footer__contact-email">
										<div className="email__logo">
											<Email />
										</div>
										<div className="footer__contact-info">
											{emails.map((email: { poshta: string }, i: number) => (
												<p key={i}>{email.poshta}</p>
											))}
											<p>info@globalstaffingsupport.com</p>
										</div>
									</div>
									{/* <div className="footer__contact-social">
										<Linkedin />
										<Instagram />
									</div> */}
								</div>
							</div>
							<div className="footer__last">
								<ul>
									<Link to='/use'>
										<li>Website Terms of Use </li>
									</Link>
									<Link to='/service'>
										<li>Terms of Service</li>
									</Link>
									<Link to='/privacy'>
										<li>Privacy Policy</li>
									</Link>
								</ul>
							</div>
						</div>
					</div>
				)
			}}
		</FirestoreCollection>
	);
};

export default Footer;
